import * as i0 from "@angular/core";
var UiErrorStateMatcher = /** @class */ (function () {
    function UiErrorStateMatcher() {
    }
    UiErrorStateMatcher.prototype.isErrorState = function (control, form) {
        return !!(control &&
            control.invalid && (control.touched ||
            control.dirty ||
            (form && form.submitted)));
    };
    UiErrorStateMatcher.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function UiErrorStateMatcher_Factory() { return new UiErrorStateMatcher(); }, token: UiErrorStateMatcher, providedIn: "root" });
    return UiErrorStateMatcher;
}());
export { UiErrorStateMatcher };
